import React, {useEffect, useState} from "react"
import {Modal, Tree} from "antd"
import CustomButton from "../../components/CustomButton"
import {useTranslation} from "react-i18next"
import {useDispatch, useSelector} from "react-redux"
import {getObjectFuncTypes} from "../NRI/ReObjectFunctionTypes/store/actions";
import LocalLoading from "../../components/Loading/Local"

const ObjectFuncTree = (props) => {
    const {visible, setVisible, setStateFuncType} = props
    const [state, setState] = useState()
    const {t} = useTranslation(['common', 'action'])
    const {isSending, objectFuncTypes} = useSelector((state) => state.reObjectFunctionTypeReducer)
    const dispatch = useDispatch()

    useEffect(() => {
        if (visible && objectFuncTypes.length === 0) {
            dispatch(getObjectFuncTypes())
        }
    }, [visible])

    function handleCancel() {
        setVisible(false)
        setState(null)
    }

    function save() {
        setVisible(false)
        setStateFuncType({...state})
    }

    const onSelect = (selectedKeys, info) => {
        let obj = objectFuncTypes.find(o => o.id === selectedKeys[0])
        setState(obj)
    };

    let treeData = objectFuncTypes?.filter(n => n.code3 === '00').map(item => {
        return {
            key: item.id,
            title: `${item.name} (${item.q})`,
            children: objectFuncTypes?.filter(n => n.parentId === item.id)
                .map((el) => ({
                    key: el.id,
                    title: `${el.name} (${el.q})`,
                    children: objectFuncTypes?.filter(n => n.parentId === el.id)
                        .map(m => ({key: m.id, title: `${m.name} (${m.q})`}))
                }))
        }
    })

    return (
        <Modal
            destroyOnHidden
            footer={[
                <CustomButton
                    key="save"
                    //loading={isSending}
                    type="green"
                    onClick={save}
                >
                    {t('action:fixSelection')}
                </CustomButton>
            ]}
            title={`${t('action:choose')} функциональное назначение объекта-аналога`}
            open={visible}
            width={900}
            onCancel={handleCancel}
        >
            {isSending
                ? <LocalLoading/>
                : <Tree
                    className='custom-select'
                    treeData={treeData}
                    onSelect={onSelect}
                />
            }
        </Modal>
    )
}
export default ObjectFuncTree
